import { SchedulesRow } from 'presentation/hospital/layouts/Home/Ambulatory'
import Heading from 'presentation/shared/components/Heading'
import TextField from 'presentation/shared/components/TextField'
import React from 'react'
import * as S from '../styles'

type Props = {
  schedule?: SchedulesRow
}

export function AmbulatoryScheduleInfo({ schedule }: Props) {
  return (
    <>
      <Heading size="large" color="primary">
        Dados do Agendamento
      </Heading>
      <S.Form>
        <div style={{ maxWidth: '335px' }}>
          <TextField
            label="Agendamento"
            disabled
            value={String(schedule?.registrationDate)}
          />
        </div>
        <div style={{ maxWidth: '335px' }}>
          <TextField label="Consulta" disabled value={schedule?.scheduleDate} />
        </div>
        <div style={{ maxWidth: '335px' }}>
          <TextField label="Horário" disabled value={String(schedule?.hour)} />
        </div>
      </S.Form>
      <S.Form>
        <div style={{ maxWidth: '335px' }}>
          <TextField
            label="Unidade de realização"
            disabled
            value={schedule?.hospitalName}
          />
        </div>
      </S.Form>
    </>
  )
}
